import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { getPropByLanguage } from "../../../../utils/Language";
import {
  SORT_TYPE_OPTIONS,
  EARNER_DEFAULT_PARAMS,
  SORT_TYPE_PRIME_OPTIONS,
} from "../../../../constants";
import useDebounce from "../../../../hook/useDebounce";
import Sort from "./mobile/Sort";
import Checkbox from "./mobile/Checkbox";
import { SearchIcon } from "../../../../components/Icons/SearchIcon";
import Price from "./desktop/Price";
import CheckboxSimple from "./desktop/CheckboxSimple";
import { itemsBreed } from "../../../../services/app";
import { useApp } from "../../../../contexts";
import CheckboxGender from "./mobile/CheckboxGender";

function FilterMobile(props) {
  const { language, T } = useApp();
  const propLang = getPropByLanguage(language);
  const {
    setFilterData,
    setCacheFilter,
    filterData,
    breedOptions,
    categoryOptions,
    rankOptions,
    type,
  } = props;
  const [open, $open] = useState([]);

  const sortOptions = useMemo(()=> {
    if (type === "nft_prime"){
      return SORT_TYPE_PRIME_OPTIONS.map((item) => {
        item.text = T(item.text);
        return item;
      })
    }else{
      return SORT_TYPE_OPTIONS.map((item) => {
        item.text = T(item.text);
        return item;
      })
    }
    
  },[type]);
  const [breedOptionLocals, $breedOptionLocals] = useState([]);
  const [rankOptionLocals, $rankOptionLocals] = useState([]);
  const [filterText, $filterText] = useState("");
  const [isSearch, $isSearch] = useState(false);
  const [categoryOptionLocals, $categoryOptionLocals] = useState([]);

  const [isMintNftOptions, $isMintNftOptions] = useState([
    { value: "1", title: "Non NFT" },
    { value: "2", title: "NFT" },
  ]);
  const [isMintNftOptionAlls, $isMintNftOptionAlls] = useState([
    { value: "", title: "All" },
    { value: "1", title: "Unmint" },
    { value: "2", title: "Minted" },
  ]);
  const [rankCode, $rankCode] = useState(filterData?.rankCode || []);
  const [genderOptions, $genderOptions] = useState([
    { value: "1", title: "Male" },
    { value: "0", title: "Female" },
    { value: "2", title: "N/A" },
  ]);
  const [artTypeOptions, $artTypeOptions] = useState([
    { value: "", title: "All" },
    { value: "photo", title: "Photo Art" },
    { value: "motion", title: "Motion Art" },
  ]);
  const [giftTypesOptions, $giftTypesOptions] = useState([
    { value: "", title: "All" },
    { value: "1", title: "Use only" },
    { value: "0", title: "Tradeable" },
  ]);
  const debouneFilterText = useDebounce(filterText, 500);

  const [sort, $sort] = useState(filterData?.sort);
  const [nftCatIds, $nftCatIds] = useState(filterData?.nftCatIds);
  const [skus, $skus] = useState(filterData?.skus);
  const [genders, $genders] = useState(filterData?.genders);
  const [isMintNft, $isMintNft] = useState(filterData?.isMintNft);
  const [priceFrom, $priceFrom] = useState(filterData?.priceFrom);
  const [priceTo, $priceTo] = useState(filterData?.priceTo);
  const [position, $position] = useState(filterData?.position);
  const [breeds, $breeds] = useState(filterData?.breeds || []);
  const [tagNFT, $tagNFT] = useState(filterData?.tagNFT || []);

  const [animationIds, $animationIds] = useState(
    filterData?.animationIds || []
  );
  const [giftTypes, $giftTypes] = useState(filterData?.giftTypes || []);

  useEffect(() => {
    if (breedOptions?.length > 0) {
      if (type === 'nft_prime') {
        const translatedBreeds = breedOptions?.map((breed) => {
          return {
            title:
              breed.description,
            value: breed.sku,
          };
        });
        $breedOptionLocals([{title: "All", value: ""}, ...translatedBreeds]);
      }else{
        const translatedBreeds = breedOptions?.map((breed) => {
          return {
            title:
              breed.groupNameTranslate[propLang] || breed.groupNameTranslate["english"],
            value: breed.collectionGroup,
          };
        });
        $breedOptionLocals(translatedBreeds);
      }
    }
  }, [breedOptions, propLang]);
  useEffect(() => {
    if (rankOptions?.length > 0) {
      const translatedRanks = rankOptions?.map((rank) => {
        return {
          title:
          rank.rankNameTranslate[propLang] || rank.rankNameTranslate["english"],
          value: rank.rankCode,
        };
      });
      $rankOptionLocals(translatedRanks);
    }
  }, [propLang, rankOptions]);

  useEffect(() => {
    if (categoryOptions?.length > 0) {
      const options = categoryOptions?.map((option) => {
        return {
          title: T(`title.${option.name.toLowerCase()}`),
          value: option.id,
        };
      });
      $categoryOptionLocals(options);
    }
  }, [categoryOptions, propLang]);

  const handleShowFilter = (val) => {
    if (val) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    $open(val);
  };

  const handleChangeSort = (val) => {
    $sort(val);
    if (type == "character") {
      setFilterData({
        sort: val,
      });
    } else {
      setFilterData({
        sort: val,
        breeds,
        rankCode,
        genders,
        priceFrom,
        priceTo,
        tagNFT,
        isMintNft,
      });
    }
  };
  const handleChangeBreeds = (val) => {
    $breeds(val);
    setCacheFilter({
      sort,
      breeds: val,
      rankCode,
      genders,
      priceFrom,
      priceTo,
      tagNFT,
      isMintNft,
    });
  };
  const handleChangeSkus = (val) => {
    $skus(val);
    setCacheFilter({
      sort,
      skus: val,
      isMintNft,
    });
  };
  const handleChangeCategory = (val) => {
    const data = val.map((v) => +v);
    $animationIds(data);
    setCacheFilter({
      animationIds: data,
      priceFrom,
      priceTo,
      giftTypes,
    });
  };
  const handleChangeRanks = (val) => {
    $rankCode(val);
    setCacheFilter({
      sort,
      breeds,
      rankCode: val,
      genders,
      priceFrom,
      priceTo,
      tagNFT,
      isMintNft,
    });
  };
  const handleChangeGenders = (val) => {
    $genders(val);
    setCacheFilter({
      sort,
      breeds,
      rankCode,
      genders: val,
      priceFrom,
      priceTo,
      tagNFT,
      isMintNft,
    });
  };
  const handleChangeMint = (val) => {
    $isMintNft(val);
    setCacheFilter({
      sort,
      breeds,
      rankCode,
      genders,
      priceFrom,
      priceTo,
      tagNFT,
      isMintNft: val,
    });
  };
  const handleChangeFilter = () => {
    if (type == "character") {
      setFilterData({
        sort,
        priceFrom,
        priceTo,
        giftTypes,
        animationIds,
      });
    } else if (type == "nft_prime"){
      setFilterData({
        sort,
        isMintNft,
        skus,
      });
    }else {
      setFilterData({
        sort,
        rankCode,
        breeds,
        genders,
        priceFrom,
        priceTo,
        tagNFT,
        isMintNft,
      });
    }

    handleShowFilter(false);
  };
  const resetFilter = () => {
    $sort(EARNER_DEFAULT_PARAMS.sort);
    $breeds([]);
    $rankCode([]);
    $genders([]);
    $priceFrom(null);
    $priceTo(null);
    $animationIds([]);
    $giftTypes([]);
    $tagNFT([]);
    $isMintNft([]);
    $skus([]);
    setCacheFilter({
      sort,
      breeds,
      rankCode,
      genders,
      tagNFT,
      priceFrom,
      priceTo,
      isMintNft,
      skus,
    });
    setFilterData(EARNER_DEFAULT_PARAMS);
    handleShowFilter(false);
  };
  const handleChangeGifts = (val) => {
    $giftTypes(val);
    setCacheFilter({
      giftTypes: val,
      priceFrom,
      priceTo,
      animationIds,
    });
  };
  const handleChangeTagNFTs = (val) => {
    $tagNFT(val);
    setCacheFilter({
      rankCode,
      breeds,
      genders,
      tagNFT: val,
      isMintNft,
      priceFrom,
      priceTo,
    });
  };
  const onChangePrice = (val) => {
    $priceFrom(val.priceFrom);
    $priceTo(val.priceTo);
    setCacheFilter({
      rankCode,
      breeds,
      genders,
      isMintNft,
      tagNFT,
      priceFrom: val.priceFrom,
      priceTo: val.priceTo,
    });
  };

  useEffect(() => {
    if (!isSearch) return;
    setFilterData({ name: debouneFilterText });
  }, [debouneFilterText]);

  useEffect(() => {
    $rankCode([]);
    $genders([]);
    $nftCatIds([]);
    $isMintNft([]);
    $skus([]);

  }, []);

  return (
    <>
      <div className="block w-full">
        <div
          className={`filter-mobile-top flex ${
            type == "character" ? "justify-start" : "justify-between"
          } items-center w-full gap-[15px] mt-[15px]`}
        >
          {(type == "character" || type == "nft_prime") && (
            <div className="flex-1 lg:mx-[15px] relative">
              <SearchIcon className="absolute left-[16px] top-[12px]" />
              <input
                type="text"
                className="h-[40px] outline-none pl-[50px] w-full max-w-full px-5 py-3 bg-white rounded-[10px] text-black "
                placeholder={type === "nft_prime" ? T("Search Art Prime Name") : T("Type anything to search")}
                onChange={(e) => {
                  $isSearch(true);
                  $filterText(e.target.value);
                }}
              />
            </div>
          )}
          <div
            className={`flex justify-center items-center h-[40px] w-[40px] bg-white gap-[8px] rounded-[10px] cursor-pointer`}
            onClick={() => handleShowFilter(true)}
          >
            <span className="flex">
              <svg
                width="22"
                height="16"
                viewBox="0 0 22 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.7541 11.4688L9.60963 11.4688C9.2746 10.1168 8.0501 9.11119 6.5945 9.11119C5.1389 9.11119 3.91471 10.1168 3.57962 11.4688L1.37748 11.4688C0.965437 11.4688 0.63159 11.8025 0.63159 12.2139C0.63159 12.6255 0.965437 12.959 1.37748 12.959L3.57962 12.959C3.91471 14.3111 5.1389 15.3168 6.5945 15.3168C8.0501 15.3168 9.2746 14.3111 9.60963 12.959L20.7541 12.959C21.1662 12.959 21.5 12.6255 21.5 12.2139C21.5 11.8025 21.1662 11.4688 20.7541 11.4688ZM6.5945 13.8266C5.70441 13.8266 4.9804 13.1033 4.9804 12.2141C4.9804 11.325 5.70441 10.6014 6.5945 10.6014C7.48465 10.6014 8.20891 11.325 8.20891 12.2141C8.20891 13.1033 7.48466 13.8266 6.5945 13.8266ZM20.7541 3.04076L18.552 3.04076C18.2169 1.68858 16.9927 0.68319 15.5371 0.68319C14.0815 0.68319 12.857 1.68858 12.522 3.04076L1.37748 3.04076C0.965436 3.04076 0.631589 3.37425 0.631589 3.78586C0.631589 4.19747 0.965436 4.53096 1.37748 4.53096L12.522 4.53096C12.857 5.88313 14.0815 6.88877 15.5371 6.88877C16.9927 6.88877 18.2169 5.88313 18.552 4.53096L20.7541 4.53096C21.1662 4.53096 21.5 4.19746 21.5 3.78586C21.5 3.37425 21.1662 3.04076 20.7541 3.04076ZM15.5371 5.39857C14.6469 5.39857 13.9227 4.67501 13.9227 3.78586C13.9227 2.8967 14.6469 2.17339 15.5371 2.17339C16.4272 2.17339 17.1512 2.8967 17.1512 3.78586C17.1512 4.67501 16.4272 5.39857 15.5371 5.39857Z"
                  fill="#101828"
                />
              </svg>
            </span>
          </div>
          <Sort
            options={sortOptions}
            filterData={filterData}
            name={"sort"}
            value={sort}
            type={type}
            onChange={handleChangeSort}
          />
        </div>
      </div>

      <div
        className={`w-full h-full fixed z-50 left-0 top-0 bg-[#F5F5F5] transition ease-in-out ${
          open === true ? "" : " -translate-x-full opacity-0"
        }`}
      >
        <div className="w-full h-screen overflow-x-hidden overflow-y-auto pt-[36px] pt-9 pb-40 px-5">
          <div className="pb-7 border-b border-solid border-black/[0.1] text-2xl font-bold text-black text-center text-aia-red">
            {T("Filter")}
          </div>
          {type == "dogmall" && (
            <>
              {/* <CheckboxGender
                title={T("Sites")}
                options={positionOptions}
                name={"position"}
                value={position}
                t={T}
                onChange={handleChangePositions}
              /> */}

              <Price
                title={T("Price")}
                priceFrom={priceFrom}
                priceTo={priceTo}
                onChange={(val) => onChangePrice(val)}
              />
              <CheckboxSimple
                title={T("Collection")}
                options={breedOptionLocals}
                name={"breeds"}
                value={breeds}
                t={T}
                onChange={handleChangeBreeds}
              />
              <Checkbox
                title={T("Rank")}
                options={rankOptionLocals}
                name={"rankCode"}
                t={T}
                value={rankCode}
                onChange={handleChangeRanks}
              />
              <CheckboxSimple
                title={T("Gender")}
                options={genderOptions}
                name={"gender"}
                value={genders}
                t={T}
                onChange={handleChangeGenders}
              />
              <Checkbox
                title={T("NFT")}
                options={isMintNftOptions}
                name={"isMintNft"}
                value={isMintNft}
                t={T}
                onChange={handleChangeMint}
              />
              <Checkbox
                title={T("Art Type")}
                options={artTypeOptions}
                name={"tagNFT"}
                value={tagNFT}
                isLastest={true}
                t={T}
                onChange={handleChangeTagNFTs}
              />
            </>
          )}
          {type == "nft_prime" && (
            <>
              <CheckboxSimple
                title={T("ART PRIME")}
                options={breedOptionLocals}
                name={"skus"}
                value={skus}
                t={T}
                onChange={handleChangeSkus}
              />
              <CheckboxGender
                title={T("Mint Status")}
                options={isMintNftOptionAlls}
                name={"isMintNft"}
                value={isMintNft}
                t={T}
                onChange={handleChangeMint}
              />
            </>
          )}
          {type == "character" && (
            <>
              <CheckboxGender
                title={T("Type")}
                options={giftTypesOptions}
                name={"giftTypes"}
                value={giftTypes}
                t={T}
                onChange={handleChangeGifts}
              />
              <Price
                title={T("Price")}
                priceFrom={priceFrom}
                priceTo={priceTo}
                onChange={(val) => onChangePrice(val)}
              />
              <Checkbox
                title={T("Animation included")}
                options={categoryOptionLocals}
                name={"animationIds"}
                value={animationIds}
                t={T}
                onChange={handleChangeCategory}
              />
            </>
          )}
        </div>

        <div className="flex items-center justify-between gap-[15px] absolute bottom-0 left-0 w-full py-7 px-5 bg-suzu-gray-1">
          <button
            className="block bg-white text-black w-full border border-solid border-[#000] max-w-40 h-[45px] rounded-[12px]"
            onClick={resetFilter}
          >
            {T("Reset")}
          </button>
          <button
            className="block bg-black text-white w-full max-w-40 h-[45px] rounded-[12px]"
            onClick={handleChangeFilter}
          >
            {T("Search")}
          </button>
        </div>
      </div>
    </>
  );
}

FilterMobile.propTypes = {
  setFilterData: PropTypes.func,
  setCacheFilter: PropTypes.func,
  changeSort: PropTypes.func,
  type: PropTypes.string,
  filterData: PropTypes.object,
  showing: PropTypes.number,
  querySort: PropTypes.number,
};

export default FilterMobile;
